import React, { useCallback } from 'react';
import { Layout, Spin } from 'antd';
import '../components/biils/Managebills.css';

import TableViewNoContext from '../components/biils/TableViewNoContext';
import BillService from '../services/Billservice';
import { useBilling } from '../hooks/useBilling';
import {
  canViewModule,
  canCreateModule,
  canUpdateModule,
  canDeleteModule,
} from '../utils/permissionUtils';

const { Content } = Layout;
const MODULE_KEY = 'manage_bills';

const ManageBillsNoContext = () => {
  const loadTables = useCallback(async () => {
    const data = await BillService.getAllTables();
    return Array.isArray(data) ? data : [];
  }, []);

  const {
    tables,
    menuItems,
    categories,
    generalSettings,
    loading,
    billModalState,
    setBillModalState,
    getTableById,
    getActiveBillsForTable,
    getBillTotal,
    refreshBillsForTable,
    createBill,
    deleteBill,
    updateBillItems,
    updateBillMeta,
    closeBill,
    splitBill,
    mergeTables,
    mergeBillsInTable,
  } = useBilling({ moduleKey: MODULE_KEY, loadTables });

  if (!canViewModule(MODULE_KEY)) {
    return (
      <Content className="bills-content">
        <div style={{ padding: 24, textAlign: 'center' }}>
          No permission to view bills
        </div>
      </Content>
    );
  }

  return (
    <Content className="bills-content">
      <Spin spinning={loading}>
        <TableViewNoContext
          tables={tables}
          menuItems={menuItems}
          categories={categories}
          generalSettings={generalSettings}
          getActiveBillsForTable={getActiveBillsForTable}
          createBill={createBill}
          billModalState={billModalState}
          setBillModalState={setBillModalState}
          getTableById={getTableById}
          deleteBill={deleteBill}
          getBillTotal={getBillTotal}
          mergeTables={mergeTables}
          mergeBillsInTable={mergeBillsInTable}
          splitBill={splitBill}
          updateBillItems={updateBillItems}
          updateBillMeta={updateBillMeta}
          closeBill={closeBill}
          refreshBillsForTable={refreshBillsForTable}
          canCreateBill={canCreateModule(MODULE_KEY)}
          canUpdateBill={canUpdateModule(MODULE_KEY)}
          canDeleteBill={canDeleteModule(MODULE_KEY)}
        />
      </Spin>
    </Content>
  );
};

export default ManageBillsNoContext;
